/* IQONIQ cart reward bar + free-gift picker (replaces Qikify). Markup/logic: snippets/iq-cart-offers.liquid.
   Refreshes every [data-iq-cart-offers] mount from ?section_id=iq-cart-offers after any cart change,
   adds the chosen gift (line property _iq_gift), and removes it if the cart no longer qualifies. */
(function () {
  if (window.__iqCartOffers) return;
  window.__iqCartOffers = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var busy = false, again = false, fixing = false, lastTry = {}, timer = null;

  function mounts() { return document.querySelectorAll('[data-iq-cart-offers]'); }

  function reloadCart() {
    if (window.T4Srequest && T4Srequest.page_type === 'cart') { location.reload(); return; }
    if (window.T4SThemeSP && T4SThemeSP.Cart && typeof T4SThemeSP.Cart.getToFetch === 'function') {
      T4SThemeSP.Cart.getToFetch();
    }
    refresh();
  }

  function post(url, body) {
    return fetch(root + url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  // remove / trim gift lines the server flagged (cart dropped below the threshold, or more than one gift)
  function enforce() {
    if (fixing) return;
    var jobs = [], seen = {};
    document.querySelectorAll('[data-iq-remove-key]').forEach(function (el) { jobs.push({ id: el.getAttribute('data-iq-remove-key'), quantity: 0 }); });
    document.querySelectorAll('[data-iq-one-key]').forEach(function (el) { jobs.push({ id: el.getAttribute('data-iq-one-key'), quantity: 1 }); });
    var now = Date.now();
    jobs = jobs.filter(function (j) {
      var k = j.id + ':' + j.quantity;
      if (seen[k] || (lastTry[k] && now - lastTry[k] < 8000)) return false; // de-dupe + no retry within 8s (no loops)
      seen[k] = lastTry[k] = now;
      return true;
    });
    if (!jobs.length) return;
    fixing = true;
    jobs.reduce(function (p, j) { return p.then(function () { return post('cart/change.js', j); }); }, Promise.resolve())
      .catch(function (e) { console.warn('iq-cart-offers', e); })
      .then(function () { fixing = false; reloadCart(); });
  }

  function refresh() {
    if (!mounts().length) return;
    if (busy) { again = true; return; }
    busy = true;
    fetch(root + '?section_id=iq-cart-offers', { credentials: 'same-origin', headers: { 'Cache-Control': 'no-cache' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var body = tmp.querySelector('[data-iq-offers-body]');
        mounts().forEach(function (m) { m.innerHTML = body ? body.outerHTML : ''; });
        if (window.jQuery) jQuery(document).trigger('currency:update');
        enforce();
        setTimeout(autoOpen, 400);
      })
      .catch(function (e) { console.warn('iq-cart-offers', e); })
      .then(function () { busy = false; if (again) { again = false; refresh(); } });
  }

  function openSheet(sheet) { if (sheet) sheet.hidden = false; }
  function closeSheets() { document.querySelectorAll('[data-iq-sheet]').forEach(function (s) { s.hidden = true; }); }

  // auto-open the gift sheet once per visit, the first time the gift unlocks while the cart is visible
  function autoOpen() {
    var cta = Array.prototype.find.call(document.querySelectorAll('[data-iq-open]'), function (b) { return b.offsetParent; });
    if (!cta) return;
    try { if (sessionStorage.getItem('iqGiftSheetShown')) return; sessionStorage.setItem('iqGiftSheetShown', '1'); } catch (err) { return; }
    openSheet(cta.parentNode.querySelector('[data-iq-sheet]'));
  }

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheets(); });

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null;
    if (t && t.closest('[data-iq-open]')) { e.preventDefault(); openSheet(t.closest('[data-iq-open]').parentNode.querySelector('[data-iq-sheet]')); return; }
    if (t && t.closest('[data-iq-close]')) { e.preventDefault(); closeSheets(); return; }
    var btn = e.target.closest && e.target.closest('[data-iq-gift-add]');
    if (!btn) return;
    e.preventDefault();
    var card = btn.closest('[data-iq-gift]');
    var sel = card && card.querySelector('[data-iq-variant]');
    var id = sel && parseInt(sel.value, 10);
    if (!id) return;
    btn.disabled = true;
    post('cart/add.js', { items: [{ id: id, quantity: 1, properties: { _iq_gift: btn.getAttribute('data-iq-tier') || '1' } }] })
      .catch(function (err) { console.warn('iq-cart-offers', err); })
      .then(reloadCart);
  });

  // The theme redraws the drawer in several ways and doesn't always fire an event, so also react
  // whenever a server-rendered "fix this gift line" flag appears anywhere on the page.
  new MutationObserver(function () {
    if (!document.querySelector('[data-iq-remove-key],[data-iq-one-key]')) return;
    clearTimeout(timer);
    timer = setTimeout(enforce, 300);
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (window.jQuery) jQuery(document).on('cart:updated', refresh);
  document.addEventListener('cart:update:count', refresh);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enforce);
  else enforce();
})();
